import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import ticketsReducer from './slices/ticketsSlice';
import locationsReducer from './slices/locationsSlice';
import attendanceReducer from './slices/attendanceSlice';
import availabilityReducer from './slices/availabilitySlice';
import escalationsReducer from './slices/escalationsSlice';
import sparesReducer from './slices/sparesSlice';
import commentsReducer from './slices/commentsSlice';
import usersReducer from './slices/usersSlice';
import permissionsReducer from './slices/permissionsSlice';
import emailTemplatesReducer from './slices/emailTemplatesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tickets: ticketsReducer,
    locations: locationsReducer,
    attendance: attendanceReducer,
    availability: availabilityReducer,
    escalations: escalationsReducer,
    spares: sparesReducer,
    comments: commentsReducer,
    users: usersReducer,
    permissions: permissionsReducer,
    emailTemplates: emailTemplatesReducer,
  }
});
